import type { IconData } from '@stacksjs/iconify-core'

export const mr4x3: IconData = {
  "body": "<path fill=\"#cd2a3e\" d=\"M0 0h640v480H0z\"/><path fill=\"#006233\" d=\"M0 72h640v336H0z\"/><path fill=\"#ffc400\" d=\"M470 154.6a150 150 0 0 1-300 0a155 155 0 0 0-5 39.2a155 155 0 1 0 310 0a154 154 0 0 0-5-39.2\" class=\"mr-st1\"/><path fill=\"#ffc400\" d=\"m320 93.8l-13.5 41.5H263l35.3 25.6l-13.5 41.4l35.3-25.6l35.3 25.6l-13.5-41.4l35.3-25.6h-43.6z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default mr4x3
